import PrivilageList from "./Privilages.json";

const RolePrivilageMap = () => {
  const comapnyCode = sessionStorage.getItem("COMPANY_CODE");
  const list = sessionStorage.getItem("ROLE_PRIVILAGES");

  const privilages = list !== null && JSON.parse(list);
  const privilagesList = privilages.role_privilege;
  const listData = [
    {
      key: 65,
      module: "divison",
    },
    {
      key: 66,
      module: "usersAttendance",
    },
    {
      key: 67,
      module: "consolidatedReport",
    },
    {
      key: 53,
      module: "workOderscheduler"
    },
    {
      key: 71,
      module: "IntelliSD"
    },
    {
      key: 72,
      module: "JobCard"
    },
    {
      key: 89,
      module: "Opportunity"
    },
    {
      key: 90,
      module: "TicketType"
    },
    {
      key:100,
      module:"editCC"
    },
    {
      key:101,
      module:'Scheduler'
    },
    {
      key:102,
      module:'invoices'
    },
    {
      key: 103,
      module: "coupon"
    },
    {
      key: 88,
      module: "DigitalAlbum"
    } as any,
    {
      key: 104,
      module: "raisePo"
    } as any,
    {
      key: 105,
      module: "approval"
    } as any,
    {
      key: 106,
      module: "payment"
    } as any,
    {
      key: 107,
      module: "customerReports"
    } as any,
    {
      key: 108,
      module: "groups"
    } as any,
    {
      key: 118,
      module: "orderDetailPage"
    } as any,
    {
      key: 119,
      module: "reconciliationReport"
    } as any,
    {
      key: 120,
      module: "accountSetup"
    } as any,
  ];

  privilagesList.map((prev, index) => {
    if (
      PrivilageList[prev.module] !== undefined &&
      prev.module !== "menuhdr_dashboard"
    ) {
      if (prev.privilege.includes("view")) {
        const newPrev = {
          key: index + "-" + PrivilageList[prev.module][0],
          module: PrivilageList[prev.module][0],
        };
        listData.push(newPrev);
      }
      if (
        prev.privilege.includes("create") &&
        PrivilageList[prev.module][1] != null
      ) {
        const newPrev = {
          key: index + "-" + PrivilageList[prev.module][1],
          module: PrivilageList[prev.module][1],
        };
        listData.push(newPrev);
      }
      if (
        prev.privilege.includes("update") &&
        PrivilageList[prev.module][2] != null
      ) {
        const newPrev = {
          key: index + "-" + PrivilageList[prev.module][2],
          module: PrivilageList[prev.module][2],
        };
        listData.push(newPrev);
      }
    } else if (prev.module === "menuhdr_dashboard") {
      if (comapnyCode === "giffy") {
        const newPrev = {
          key: index + "-" + PrivilageList[prev.module][0],
          module: PrivilageList[prev.module][0],
        };
        listData.push(newPrev);
      } else if (comapnyCode === "pubert" || comapnyCode === "srinss" || comapnyCode === "brighthcg" || comapnyCode ==="firsthcg" || comapnyCode === "slnca") {
        const newPrev = {
          key: index + "-" + PrivilageList[prev.module][1],
          module: PrivilageList[prev.module][1],
        };
        listData.push(newPrev);
      } else if (comapnyCode === "karnatakastatehea") {
        const newPrev = {
          key: index + "-" + PrivilageList[prev.module][2],
          module: PrivilageList[prev.module][2],
        };
        listData.push(newPrev);
      } else if (comapnyCode === "asmpro") {
        const newPrev = {
          key: index + "-" + PrivilageList[prev.module][2],
          module: PrivilageList[prev.module][2],
        };
        listData.push(newPrev);
      }
    }
  });
  return listData;
};

export default RolePrivilageMap;
